import { calendarBookingSlots, calendarSuggestedFollowUp } from '@uplift/api';
import { DateFormats } from '@uplift/constants';
import { CalendarDateService } from '@uplift/services';
import { useQuery } from '@tanstack/react-query';
import { BaseQueryOpts } from '../baseTypes';


export const useBookingSlotsQuery = (date: string, timezone: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'calendar', date, 'booking-slots' ],
    queryFn: async () => {
      const dateObj = CalendarDateService.date.tz(date, DateFormats.ISO_DATE, timezone);

      const bookingSlotsResponse = await calendarBookingSlots({
        datetime_from: dateObj.startOf('day').utc().format(),
        datetime_to: dateObj.endOf('day').utc().format(),
      });

      return new Set(bookingSlotsResponse?.available_slots);
    },
    ...opts,
  });
};


export const useSuggestedFollowUpQuery = (sessionStart: string, intervalDays: number, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'calendar', sessionStart, intervalDays, 'suggested-follow-up' ],
    queryFn: async () => {
      const response = await calendarSuggestedFollowUp({
        session_start: sessionStart,
        interval_days: intervalDays,
      });

      return response.data.suggestedAt;
    },
    ...opts,
  });
};
